// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./styles/Variables/Variables.scss";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  max-width: 100vw;
  overflow-x: hidden;
}

body {
  font-family: 'Urbanist', serif;
  font-optical-sizing: auto;
  font-style: normal;
}

.bt {
  background: none !important;
  border: none !important;
}

div.offcanvas:has(input) {
  height: clamp(60px, 13vh, 150px) !important;
}

h1,
h2,
h3,
h4,
h5 {
  margin: 0 !important;
  margin-bottom: 0;
}

/* static start */
button,
input,
optgroup,
select,
textarea {
  font-family: 'Noto Sans', sans-serif;
}

a {
  color: inherit;
  text-decoration: none !important;
  color: #2a2a2a;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

img {
  height: auto;
}

button {
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.accordion-button:focus {
  outline: 0;
  box-shadow: none !important;
}

.navright a {
  padding: 7px 0px;
  margin-right: 14px;
  color: #2a2a2a;
  font-weight: 600;
}

.navright button {
  background: #205440;
  color: #fff;
  padding: 8px 20px;
  border: none;
  border-radius: 10px;
}

.navbar a {
  color: #2a2a2a;
}

.navbar_outer {
  box-shadow: 1px 1px 32px #cccccc59;
}

.logo img {
  color: transparent;
  max-width: 48px;
  height: auto;
}

main {
  min-height: 100vh;
}

.text_top_cnt h1 {
  font-weight: 600;
  font-size: 32px;
}

.text_top_cnt {
  margin-bottom: 30px;
}

.text_bottom_cnt {
  margin-top: 30px;
}

.text_bottom_cnt h3 {
  font-weight: 600;
  font-size: 28px;
}

.common_tab {
  margin: 30px 0px;
}

.common_tab .tab-content {
  border: solid 1px #dee2e6;
  padding: 20px;
  border-radius: 4px;
  background: #282828;
  color: #f58e08;
}

.text_bottom_cnt textarea {
  width: 100%;
  min-height: 200px;
  background: #000;
  color: #fff;
}

@media screen and (max-width: 767px) {
  .foot_text_center {
    text-align: left;
  }
}

/* static end */
/* navbar 2 */
.navbar2 .dropdown,
.dropdown-center,
.dropend,
.dropstart,
.dropup,
.dropup-center {
  position: inherit !important;
}

.navbar2 .navbar-expand-lg .navbar-nav .dropdown-menu {
  width: 100%;
}

@media (min-width: 992px) {
  .navbar2 .navbar-expand-lg .navbar-collapse {
    align-items: center;
    justify-content: space-evenly;
  }

  .navbar2 .navbar-collapse .me-auto {
    margin-right: inherit !important;
  }
}

.navbar2 .m_block {
  display: none !important;
}

@media (max-width: 992px) {
  .navbar2 .m_block {
    display: flex !important;
  }

  .navbar2 .m_none {
    display: none !important;
  }
}

/* navbar 2 end */
/* navbar 4  */
.navbar4 .mob_block {
  display: none;
}

@media (max-width: 992px) {
  .navbar4 .user_left {
    align-items: normal !important;
  }

  .navbar4 .mob_none {
    display: none;
  }

  .navbar4 .mob_block {
    display: block;
  }
}

/* navbar 4 end */
/* footer 1 */
.footer1 .page-footer {
  padding-top: 20px;
  color: #fff;
  background-color: #ee6e73;
}

.footer1 .grey-text.text-lighten-4 {
  color: #f5f5f5 !important;
}

.footer1 .page-footer ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

.footer1 .page-footer ul li a {
  color: #fff;
  font-size: 14px;
}

.footer1 .page-footer .footer-copyright {
  min-height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0px;
  color: rgba(255, 255, 255, 0.8);
  background-color: rgba(51, 51, 51, 0.08);
}

.footer1 .page-footer .right {
  float: right !important;
}

.footer1 .page-footer .footer-copyright p {
  display: inline-block;
  margin: 0;
  font-size: 14px;
}

.footer1 .page-footer .footer-copyright a {
  display: inline-block;
  padding: 2px 5px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
}

.footer1 .page-footer .footertop {
  padding: 30px;
}

.footer1 .foot_bottom_right {
  float: right;
}

.dongle_menu {
  border: none;
  width: 36px;
  height: 36px;
  left: inherit;
  position: absolute;
  padding: 0;
  background: none;
  top: 28px;
  right: -17px;
  z-index: 15555;
}

.admin-header {
  height: 96px;
}

.logout_menu {
  padding-top: 81px !important;
}

/* width */
::-webkit-scrollbar {
  width: 1px;
  height: 3px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgb(219, 219, 219);
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #0f4d0f;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #0f4d0f;
}

.backbutton {
  display: inline-block;
  width: 100px;
  margin-bottom: 31px;
  background-color: #fff;
  border-radius: 5px;
}

.backbutton a {
  color: #000;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  display: flex;
  padding: 13px 40px;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.backbutton svg {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}

/* tab */
.tab_head {
  position: relative;
}

.out_tap .nav-tabs {
  text-align: right;
  justify-content: end;
  gap: 38px;
  border: none;
  min-height: 30px;
  padding: 0px 0px 24px;
  border-bottom: dashed 1px #c7dadd;
  margin-bottom: 24px !important;
}

.out_tap .nav-tabs .nav-link {
  border: none;
  color: #2a2a2a !important;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  padding: 0 0px 3px;
}

.out_tap .nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
  border-radius: 0px 0px 3px 3px !important;
  border-bottom: #228b22 solid 4px !important;
}

/* tab inner */
.inner_tab_head {
  width: 100%;
  overflow-x: auto;
}

/* width */
.inner_tab_head::-webkit-scrollbar {
  width: 0px;
}

/* Track */
.inner_tab_head::-webkit-scrollbar-track {
  box-shadow: none;
  border-radius: 10px;
}

/* Handle */
.inner_tab_head::-webkit-scrollbar-thumb {
  background: #ffffff;
  border-radius: 10px;
}

/* Handle on hover */
.inner_tab_head::-webkit-scrollbar-thumb:hover {
  background: #ffffff;
}

.tab-content .inner_tab_head .nav-tabs {
  text-align: right;
  justify-content: end;
  gap: 38px;
  border: none;
  min-height: 38px;
  border-radius: 8px;
  background: #f5f6fa;
  padding: 4px;
  min-width: 556px;
}

.tab-content .inner_tab_head .nav-tabs .nav-link {
  color: var(--Neutrals-Text-Black, #2a2a2a);
  font-size: 14px;
  font-style: normal;
  background: none;
  font-weight: 600;
  line-height: 17.505px;
  /* 125.033% */
  padding: 11px;
}

.tab-content .inner_tab_head .nav-link.active {
  border-radius: 6px !important;
  background: #fff !important;
  border: none !important;
}

.tab-content .inner_tab_head .nav-item {
  position: relative;
}

.tab-content .inner_tab_head .nav-item::after {
  position: absolute;
  content: '';
  right: -15px;
  height: 20px;
  width: 1px;
  background-color: #666;
  bottom: 0;
  top: 0;
  margin: auto;
}

.tab-content .inner_tab_head .nav-item:last-child:after {
  display: none;
}

.tab_head h1 {
  position: absolute;
  color: var(--Neutrals-Text-Black, #1a1a1a);
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  top: -4px;
}

.resp_table {
  min-width: 571px;
}

.resp_table tr {
  border: none !important;
}
tbody,
td,
tfoot,
th,
thead,
tr {
  border: none !important;
}

.resp_table th {
  color: #2a2a2a !important;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  border: none !important;
  text-transform: uppercase;
  white-space: nowrap;
  padding: 10px 0px !important;
  text-align: center;
}

.resp_table th:first-child {
  text-align: left;
}

.resp_table td {
  color: #475254 !important;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  border: none !important;
  line-height: normal;
  padding: 36px 0px 0px !important;
  text-align: center;
}
body .form-select:focus {
  border-color: #e1e7ec;
  outline: 0;
  box-shadow: none;
}
.resp_table td:first-child {
  text-align: left;
}

.table_select .form-select {
  height: 44px;
  padding: 8.752px 15px;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;
  border: 1.094px solid #e1e7ec;
  color: #2a2a2a;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18.015px;
  margin-bottom: 16px;
}

.overview_outer {
  padding: 20px;
  border-bottom: dashed 1px #c7dadd;
  margin-bottom: 24px !important;
}


.graph_section {
  border-bottom: dashed 1px #c7dadd;
  margin-bottom: 0px !important;
  padding: 0px;
}
.graph_sectionh3{
  font-weight: 600;
  font-size: 24px;
  line-height: 100%;
  color: #0f4d0f !important;
}
.graph_sectionp{
  margin-bottom: 0 !important;
font-weight: 500;
font-size: 15px;
line-height: 49.6px;
letter-spacing: 0%;
color: #666666;
}
.graph_sectionn p{
font-weight: 400;
font-size: 16px;
line-height: 100%;
letter-spacing: 0%;
text-align: right;
margin-bottom: 24px;
}
.graph_sectionn{
border-bottom: dashed 1px #c7dadd;
margin-top: 16px;
}
.graph_sectionw{
  border-bottom: dashed 0px #c7dadd;
  margin-top: 16px;
  }
  .graph_sectionw p  {
    font-weight: 400;
    font-size: 16px;
    line-height: 100%;
    letter-spacing: 0%;
    text-align: right;
    margin-bottom: 8px;
    margin-top: 16px;
    color: #666666;
}
.weightborderbottom{
  border-top: dashed 1px #c7dadd;
}
.overview_outer h3 {
  color: var(--Accent-Secondary, #0f4d0f);
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.overview_outer h5 {
  color: var(--Neutrals-Text-Black, #2a2a2a);
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 22px;
  padding: 6px 0px;
}

.overview_outer h6 {
  color: var(--Neutrals-Grey, #666);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px;
  padding: 6px 0px;
}

.overview_outer p {
  color: var(--Neutrals-Text-Black, #2a2a2a);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.overview_outer h6 span {
  color: var(--Neutrals-Grey, #666);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 21px;
  /* 131.25% */
}
.main_cnt {
  margin-top: 31px;
}
.main_cnt .tab-content>.active {
  overflow-x: auto;
}
.logout_link {
  margin-top: 72px;
}
.logout_link span {
  color: var(--State-Red, #e35151);
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
@media (max-width: 767px) {
  .resp_table {
    min-width: auto;
  }
  .overview_outer .boxsec{
    flex-wrap: wrap;
    gap: 10px !important;
    text-align: center;
    justify-content: center !important;
  }
  .overview_outer {
    text-align: center;
}


  .overview_outer .boxsec .box p{
margin-bottom: 0 !important;  }
  .inner_tab_head {
    width: 100%;
    overflow-x: visible;
}
.resp_table th {
  color: #2a2a2a !important;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  border: none !important;
  text-transform: uppercase;
  white-space: nowrap;
  padding: 10px 10px !important;
  text-align: center;
}

.tab-content .inner_tab_head .nav-tabs {
  min-width: 150px !important;
  gap: 15px !important;
  width: 100%;
}

  .footer1 .foot_bottom_right {
    float: left;
    width: 100%;
  }

  .mobilemenu {
    display: block !important;
    position: absolute;
    top: 7px;
    right: -39px;
    z-index: 155555;
    width: 37px;
    left: auto;
  }

  .tab_head h1 {
    position: relative;
    top: 0px;
    margin-bottom: 20px !important;
  }

  .out_tap .nav-tabs {
    text-align: center !important;
    justify-content: space-between !important;
    gap: 28px !important;
    min-height: 30px !important;
    margin-bottom: 24px !important;
  }
}

/* footer 1 end */

.preview-section {
  border: 1px solid #eee;
  border-left: 0;
  border-right: 0;
}

.container {
  padding: 0 15px;
}
`, "",{"version":3,"sources":["webpack://./src/globals.css"],"names":[],"mappings":"AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;;;;;EAKE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;;;;;EAKE,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,cAAc;EACd;gEAC8D;AAChE;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;gEAC8D;AAChE;;AAEA;EACE,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,eAAe;AACf,aAAa;AACb;;;;;;EAME,4BAA4B;AAC9B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,mBAAmB;IACnB,6BAA6B;EAC/B;;EAEA;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA,iBAAiB;AACjB,cAAc;AACd;EACE,aAAa;AACf;;AAEA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,iBAAiB;AACjB,aAAa;AACb;EACE,iBAAiB;EACjB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EAIb,mBAAmB;EAInB,8BAA8B;EAC9B,iBAAiB;EACjB,+BAA+B;EAC/B,wCAAwC;AAC1C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,UAAU;AACV;EACE,UAAU;EACV,WAAW;AACb;;AAEA,UAAU;AACV;EACE,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,QAAQ;AACR;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,yCAAyC;EACzC,2CAA2C;AAC7C;;AAEA,cAAc;AACd;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,UAAU;AACZ;;AAEA,UAAU;AACV;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,sBAAsB;EACtB,SAAS;EACT,MAAM;EACN,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;AACA;;;;;;EAME,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,8BAA8B;AAChC;;;AAGA;EACE,iCAAiC;EACjC,6BAA6B;EAC7B,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,2BAA2B;AAC7B,gBAAgB;AAChB,eAAe;AACf,mBAAmB;AACnB,kBAAkB;AAClB,cAAc;AACd;AACA;AACA,gBAAgB;AAChB,eAAe;AACf,iBAAiB;AACjB,kBAAkB;AAClB,iBAAiB;AACjB,mBAAmB;AACnB;AACA;AACA,iCAAiC;AACjC,gBAAgB;AAChB;AACA;EACE,iCAAiC;EACjC,gBAAgB;EAChB;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,uCAAuC;EACvC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,kCAAkC;EACpC;EACA;IACE,kBAAkB;AACtB;;;EAGE;AACF,2BAA2B,GAAG;EAC5B;IACE,WAAW;IACX,mBAAmB;AACvB;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,WAAW;AACb;;EAEE;IACE,WAAW;IACX,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,eAAe;IACf,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,8BAA8B;EAChC;;EAEA;IACE,6BAA6B;IAC7B,yCAAyC;IACzC,oBAAoB;IACpB,2BAA2B;IAC3B,8BAA8B;EAChC;AACF;;AAEA,iBAAiB;;AAEjB;EACE,sBAAsB;EACtB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB","sourcesContent":["@import './styles/Variables/Variables.scss';\n@import url('https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap');\nhtml,\nbody {\n  max-width: 100vw;\n  overflow-x: hidden;\n}\n\nbody {\n  font-family: 'Urbanist', serif;\n  font-optical-sizing: auto;\n  font-style: normal;\n}\n\n.bt {\n  background: none !important;\n  border: none !important;\n}\n\ndiv.offcanvas:has(input) {\n  height: clamp(60px, 13vh, 150px) !important;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5 {\n  margin: 0 !important;\n  margin-bottom: 0;\n}\n\n/* static start */\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font-family: 'Noto Sans', sans-serif;\n}\n\na {\n  color: inherit;\n  text-decoration: none !important;\n  color: #2a2a2a;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,\n    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\nimg {\n  height: auto;\n}\n\nbutton {\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,\n    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n.accordion-button:focus {\n  outline: 0;\n  box-shadow: none !important;\n}\n\n.navright a {\n  padding: 7px 0px;\n  margin-right: 14px;\n  color: #2a2a2a;\n  font-weight: 600;\n}\n\n.navright button {\n  background: #205440;\n  color: #fff;\n  padding: 8px 20px;\n  border: none;\n  border-radius: 10px;\n}\n\n.navbar a {\n  color: #2a2a2a;\n}\n\n.navbar_outer {\n  box-shadow: 1px 1px 32px #cccccc59;\n}\n\n.logo img {\n  color: transparent;\n  max-width: 48px;\n  height: auto;\n}\n\nmain {\n  min-height: 100vh;\n}\n\n.text_top_cnt h1 {\n  font-weight: 600;\n  font-size: 32px;\n}\n\n.text_top_cnt {\n  margin-bottom: 30px;\n}\n\n.text_bottom_cnt {\n  margin-top: 30px;\n}\n\n.text_bottom_cnt h3 {\n  font-weight: 600;\n  font-size: 28px;\n}\n\n.common_tab {\n  margin: 30px 0px;\n}\n\n.common_tab .tab-content {\n  border: solid 1px #dee2e6;\n  padding: 20px;\n  border-radius: 4px;\n  background: #282828;\n  color: #f58e08;\n}\n\n.text_bottom_cnt textarea {\n  width: 100%;\n  min-height: 200px;\n  background: #000;\n  color: #fff;\n}\n\n@media screen and (max-width: 767px) {\n  .foot_text_center {\n    text-align: left;\n  }\n}\n\n/* static end */\n/* navbar 2 */\n.navbar2 .dropdown,\n.dropdown-center,\n.dropend,\n.dropstart,\n.dropup,\n.dropup-center {\n  position: inherit !important;\n}\n\n.navbar2 .navbar-expand-lg .navbar-nav .dropdown-menu {\n  width: 100%;\n}\n\n@media (min-width: 992px) {\n  .navbar2 .navbar-expand-lg .navbar-collapse {\n    align-items: center;\n    justify-content: space-evenly;\n  }\n\n  .navbar2 .navbar-collapse .me-auto {\n    margin-right: inherit !important;\n  }\n}\n\n.navbar2 .m_block {\n  display: none !important;\n}\n\n@media (max-width: 992px) {\n  .navbar2 .m_block {\n    display: flex !important;\n  }\n\n  .navbar2 .m_none {\n    display: none !important;\n  }\n}\n\n/* navbar 2 end */\n/* navbar 4  */\n.navbar4 .mob_block {\n  display: none;\n}\n\n@media (max-width: 992px) {\n  .navbar4 .user_left {\n    align-items: normal !important;\n  }\n\n  .navbar4 .mob_none {\n    display: none;\n  }\n\n  .navbar4 .mob_block {\n    display: block;\n  }\n}\n\n/* navbar 4 end */\n/* footer 1 */\n.footer1 .page-footer {\n  padding-top: 20px;\n  color: #fff;\n  background-color: #ee6e73;\n}\n\n.footer1 .grey-text.text-lighten-4 {\n  color: #f5f5f5 !important;\n}\n\n.footer1 .page-footer ul {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.footer1 .page-footer ul li a {\n  color: #fff;\n  font-size: 14px;\n}\n\n.footer1 .page-footer .footer-copyright {\n  min-height: 50px;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  padding: 10px 0px;\n  color: rgba(255, 255, 255, 0.8);\n  background-color: rgba(51, 51, 51, 0.08);\n}\n\n.footer1 .page-footer .right {\n  float: right !important;\n}\n\n.footer1 .page-footer .footer-copyright p {\n  display: inline-block;\n  margin: 0;\n  font-size: 14px;\n}\n\n.footer1 .page-footer .footer-copyright a {\n  display: inline-block;\n  padding: 2px 5px;\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.footer1 .page-footer .footertop {\n  padding: 30px;\n}\n\n.footer1 .foot_bottom_right {\n  float: right;\n}\n\n.dongle_menu {\n  border: none;\n  width: 36px;\n  height: 36px;\n  left: inherit;\n  position: absolute;\n  padding: 0;\n  background: none;\n  top: 28px;\n  right: -17px;\n  z-index: 15555;\n}\n\n.admin-header {\n  height: 96px;\n}\n\n.logout_menu {\n  padding-top: 81px !important;\n}\n\n/* width */\n::-webkit-scrollbar {\n  width: 1px;\n  height: 3px;\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 5px rgb(219, 219, 219);\n  border-radius: 10px;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: #0f4d0f;\n  border-radius: 10px;\n}\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n  background: #0f4d0f;\n}\n\n.backbutton {\n  display: inline-block;\n  width: 100px;\n  margin-bottom: 31px;\n  background-color: #fff;\n  border-radius: 5px;\n}\n\n.backbutton a {\n  color: #000;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  display: flex;\n  padding: 13px 40px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n}\n\n.backbutton svg {\n  width: 24px;\n  height: 24px;\n  flex-shrink: 0;\n}\n\n/* tab */\n.tab_head {\n  position: relative;\n}\n\n.out_tap .nav-tabs {\n  text-align: right;\n  justify-content: end;\n  gap: 38px;\n  border: none;\n  min-height: 30px;\n  padding: 0px 0px 24px;\n  border-bottom: dashed 1px #c7dadd;\n  margin-bottom: 24px !important;\n}\n\n.out_tap .nav-tabs .nav-link {\n  border: none;\n  color: #2a2a2a !important;\n  text-align: center;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  padding: 0 0px 3px;\n}\n\n.out_tap .nav-tabs .nav-item.show .nav-link,\n.nav-tabs .nav-link.active {\n  border-radius: 0px 0px 3px 3px !important;\n  border-bottom: #228b22 solid 4px !important;\n}\n\n/* tab inner */\n.inner_tab_head {\n  width: 100%;\n  overflow-x: auto;\n}\n\n/* width */\n.inner_tab_head::-webkit-scrollbar {\n  width: 0px;\n}\n\n/* Track */\n.inner_tab_head::-webkit-scrollbar-track {\n  box-shadow: none;\n  border-radius: 10px;\n}\n\n/* Handle */\n.inner_tab_head::-webkit-scrollbar-thumb {\n  background: #ffffff;\n  border-radius: 10px;\n}\n\n/* Handle on hover */\n.inner_tab_head::-webkit-scrollbar-thumb:hover {\n  background: #ffffff;\n}\n\n.tab-content .inner_tab_head .nav-tabs {\n  text-align: right;\n  justify-content: end;\n  gap: 38px;\n  border: none;\n  min-height: 38px;\n  border-radius: 8px;\n  background: #f5f6fa;\n  padding: 4px;\n  min-width: 556px;\n}\n\n.tab-content .inner_tab_head .nav-tabs .nav-link {\n  color: var(--Neutrals-Text-Black, #2a2a2a);\n  font-size: 14px;\n  font-style: normal;\n  background: none;\n  font-weight: 600;\n  line-height: 17.505px;\n  /* 125.033% */\n  padding: 11px;\n}\n\n.tab-content .inner_tab_head .nav-link.active {\n  border-radius: 6px !important;\n  background: #fff !important;\n  border: none !important;\n}\n\n.tab-content .inner_tab_head .nav-item {\n  position: relative;\n}\n\n.tab-content .inner_tab_head .nav-item::after {\n  position: absolute;\n  content: '';\n  right: -15px;\n  height: 20px;\n  width: 1px;\n  background-color: #666;\n  bottom: 0;\n  top: 0;\n  margin: auto;\n}\n\n.tab-content .inner_tab_head .nav-item:last-child:after {\n  display: none;\n}\n\n.tab_head h1 {\n  position: absolute;\n  color: var(--Neutrals-Text-Black, #1a1a1a);\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  top: -4px;\n}\n\n.resp_table {\n  min-width: 571px;\n}\n\n.resp_table tr {\n  border: none !important;\n}\ntbody,\ntd,\ntfoot,\nth,\nthead,\ntr {\n  border: none !important;\n}\n\n.resp_table th {\n  color: #2a2a2a !important;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  border: none !important;\n  text-transform: uppercase;\n  white-space: nowrap;\n  padding: 10px 0px !important;\n  text-align: center;\n}\n\n.resp_table th:first-child {\n  text-align: left;\n}\n\n.resp_table td {\n  color: #475254 !important;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  border: none !important;\n  line-height: normal;\n  padding: 36px 0px 0px !important;\n  text-align: center;\n}\nbody .form-select:focus {\n  border-color: #e1e7ec;\n  outline: 0;\n  box-shadow: none;\n}\n.resp_table td:first-child {\n  text-align: left;\n}\n\n.table_select .form-select {\n  height: 44px;\n  padding: 8.752px 15px;\n  justify-content: space-between;\n  align-items: center;\n  border-radius: 8px;\n  border: 1.094px solid #e1e7ec;\n  color: #2a2a2a;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18.015px;\n  margin-bottom: 16px;\n}\n\n.overview_outer {\n  padding: 20px;\n  border-bottom: dashed 1px #c7dadd;\n  margin-bottom: 24px !important;\n}\n\n\n.graph_section {\n  border-bottom: dashed 1px #c7dadd;\n  margin-bottom: 0px !important;\n  padding: 0px;\n}\n.graph_sectionh3{\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 100%;\n  color: #0f4d0f !important;\n}\n.graph_sectionp{\n  margin-bottom: 0 !important;\nfont-weight: 500;\nfont-size: 15px;\nline-height: 49.6px;\nletter-spacing: 0%;\ncolor: #666666;\n}\n.graph_sectionn p{\nfont-weight: 400;\nfont-size: 16px;\nline-height: 100%;\nletter-spacing: 0%;\ntext-align: right;\nmargin-bottom: 24px;\n}\n.graph_sectionn{\nborder-bottom: dashed 1px #c7dadd;\nmargin-top: 16px;\n}\n.graph_sectionw{\n  border-bottom: dashed 0px #c7dadd;\n  margin-top: 16px;\n  }\n  .graph_sectionw p  {\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 100%;\n    letter-spacing: 0%;\n    text-align: right;\n    margin-bottom: 8px;\n    margin-top: 16px;\n    color: #666666;\n}\n.weightborderbottom{\n  border-top: dashed 1px #c7dadd;\n}\n.overview_outer h3 {\n  color: var(--Accent-Secondary, #0f4d0f);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\n.overview_outer h5 {\n  color: var(--Neutrals-Text-Black, #2a2a2a);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  margin-bottom: 22px;\n  padding: 6px 0px;\n}\n\n.overview_outer h6 {\n  color: var(--Neutrals-Grey, #666);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 21px;\n  padding: 6px 0px;\n}\n\n.overview_outer p {\n  color: var(--Neutrals-Text-Black, #2a2a2a);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.overview_outer h6 span {\n  color: var(--Neutrals-Grey, #666);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 21px;\n  /* 131.25% */\n}\n.main_cnt {\n  margin-top: 31px;\n}\n.main_cnt .tab-content>.active {\n  overflow-x: auto;\n}\n.logout_link {\n  margin-top: 72px;\n}\n.logout_link span {\n  color: var(--State-Red, #e35151);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n@media (max-width: 767px) {\n  .resp_table {\n    min-width: auto;\n  }\n  .overview_outer .boxsec{\n    flex-wrap: wrap;\n    gap: 10px !important;\n    text-align: center;\n    justify-content: center !important;\n  }\n  .overview_outer {\n    text-align: center;\n}\n\n\n  .overview_outer .boxsec .box p{\nmargin-bottom: 0 !important;  }\n  .inner_tab_head {\n    width: 100%;\n    overflow-x: visible;\n}\n.resp_table th {\n  color: #2a2a2a !important;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  border: none !important;\n  text-transform: uppercase;\n  white-space: nowrap;\n  padding: 10px 10px !important;\n  text-align: center;\n}\n\n.tab-content .inner_tab_head .nav-tabs {\n  min-width: 150px !important;\n  gap: 15px !important;\n  width: 100%;\n}\n\n  .footer1 .foot_bottom_right {\n    float: left;\n    width: 100%;\n  }\n\n  .mobilemenu {\n    display: block !important;\n    position: absolute;\n    top: 7px;\n    right: -39px;\n    z-index: 155555;\n    width: 37px;\n    left: auto;\n  }\n\n  .tab_head h1 {\n    position: relative;\n    top: 0px;\n    margin-bottom: 20px !important;\n  }\n\n  .out_tap .nav-tabs {\n    text-align: center !important;\n    justify-content: space-between !important;\n    gap: 28px !important;\n    min-height: 30px !important;\n    margin-bottom: 24px !important;\n  }\n}\n\n/* footer 1 end */\n\n.preview-section {\n  border: 1px solid #eee;\n  border-left: 0;\n  border-right: 0;\n}\n\n.container {\n  padding: 0 15px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
